import { InMemoryOriginsRepository } from "../../../../../test/repositories/inMemoryOriginsRepository"
import { makeOrigin } from "../../../../../test/factories/makeOrigin"
import { randomUUID } from "node:crypto"
import { IGetOriginByIdProtocol } from "../../protocols/origin/IGetOriginByIdProtocol"
import { GetOriginByIdUseCase } from "./getOriginById"

let sut: IGetOriginByIdProtocol
let repository: InMemoryOriginsRepository

describe('Get Origin By Id', () => {
  beforeEach(() => {
    repository = new InMemoryOriginsRepository()
    sut = new GetOriginByIdUseCase(repository)
  })
  it('Should be able to get a origin by id', async () => {
    const originId = randomUUID()
    const originOnDatabase = makeOrigin({
      name: 'Test Origin'
   }, originId)
   await repository.create(originOnDatabase)

   const { origin } = await sut.execute({
    originId
   })

    expect(origin.name).toEqual('Test Origin')
  })

  it('Should not be able to get a origin that not exists', async () => {
    expect(() => {
      return sut.execute({
        originId: ''
      })
    }).rejects.toBeInstanceOf(Error)
  })
})